import React from "react"
import { useNavigate } from "react-router-dom";
import { useLocation } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import { isEqual } from "lodash";

import 'react-tabs/style/react-tabs.css';

import * as PD from '../classes/pdStyle';
import {getParam} from '../utils/utils';

import Buffering from "../components/Buffering"; 

import dsd from "../classes/clsDSD";

import ViewDesignItem from "../components/ViewDesignItem";
import ViewDesign from "../components/ViewDesign";
import ViewMetadata from "../components/ViewMetadata";

import {getDesign, getDesignItem, addDesignItemToDesign, editDesignItem} from "../utils/utilsDesign";

import { DesignerLayoutContext } from '../contexts/DesignerLayoutContext';

class DesignItem extends React.Component {

    static contextType = DesignerLayoutContext;

    constructor(props) {
        super(props);
        this.state = {
            mode: 'view',
            renderState: null
        };

        this.data = {};

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleMode = this.handleMode.bind(this);
        this.handleButton = this.handleButton.bind(this);

        this.dsd = new dsd();
        this.dsd.StateObject = this;

    }

    componentDidMount(){
       this.setup();
    }

    componentDidUpdate(prevProps, prevState){
        if (!isEqual(this.props, prevProps)){
            this.setup();
        }
    }
    
    loadDesign(id){

        let StateChange = {};
        StateChange.Design = null;

        const onLoad = function(data){
            let StateChange = {};
            StateChange.Design = data;
            StateChange.renderState = "loaded";
            this.setState(StateChange);
            return;
        }.bind(this);

        const onFail = function(e){
            let StateChange = {};
            StateChange.Design = null;
            StateChange.renderState = "failed";

            StateChange.errorMessage = e.message;    
            if (e.response){
                if (e.response.data){
                    if (e.response.data.message){
                        StateChange.errorMessage = e.response.data.message;
                    }
                }
            }
            this.setState(StateChange);
            return;
        }.bind(this);

        if (id){
            StateChange.renderState = "loading";
            getDesign(this.dsd, id, onLoad, onFail);
        }

        this.setState(StateChange);

        return;                
    };

    loadDesignItem(id){

        let StateChange = {};
        StateChange.DesignItem = null;

        const onLoad = function(data){
            let StateChange = {};
            StateChange.DesignItem = data;

            StateChange.FormData = data;

            if (data.Design){
                StateChange.Design = data.Design;
                if (this.context.hasLayout){
                    this.context.Layout.setLeftAsDesign(data.Design._id);
                }
            }

            StateChange.renderState = "loaded";

            StateChange.OfferEdit = false;
            try{
                if (this.dsd.loggedon){
                    if (StateChange.DesignItem.Design.idUser == this.dsd.user.id){
                        StateChange.OfferEdit = true;
                    }
                }
            }
            catch{

            }   

            if (!StateChange.OfferEdit){
                switch (this.state.mode){
                    case "edit":
                    case "remove":
                        StateChange.renderState = "denied"
                        StateChange.errorMessage = "You cannot add or edit this Design Item"
                    break;
                }
            }

            this.setState(StateChange);
            return;
        }.bind(this);

        const onFail = function(e){
            let StateChange = {};
            StateChange.DesignItem = null;
            StateChange.renderState = "failed";

            StateChange.errorMessage = e.message;    
            if (e.response){
                if (e.response.data){
                    if (e.response.data.message){
                        StateChange.errorMessage = e.response.data.message;
                    }
                }
            }
            this.setState(StateChange);
            return;
        }.bind(this);

        if (id){
            StateChange.renderState = "loading";
            getDesignItem(this.dsd, id, onLoad, onFail);
        }

        this.setState(StateChange);

        return;      
        
    };

    setup(){

        let StateChange = {

            mode: "view",

            idDesignItem: null,
            idDesign: null,

            Design: null,
            DesignItem: null,

            isUpdated: false,

            isFailed: false,
            isError: false,
            errorMessage: null,

            renderState: null,

            FormData: {},
            OfferEdit:false,
            fallbackpath: null

        }

        if (getParam('mode', this.props)){
            StateChange.mode = getParam('mode', this.props);
        }
        StateChange.idDesignItem = getParam('id', this.props);
        StateChange.idDesign = getParam('idDesign', this.props);

        switch (StateChange.mode){
            case 'new':
                if (!StateChange.idDesign){
                    StateChange.renderState = "invalid";
                    StateChange.errorMessage = "Design not specified when adding a Design Item"
                }
                break;
            default:
                if (StateChange.idDesign){
                    StateChange.renderState = "invalid";
                    StateChange.errorMessage = "Design should not be specified for an existing Design Item"
                }
                if (!StateChange.idDesignItem){
                    StateChange.renderState = "invalid";
                    StateChange.errorMessage = "Design Item not specified"
                }
                break;
        }

        if (StateChange.idDesign){
            this.loadDesign(StateChange.idDesign);
        }
        if (StateChange.idDesignItem){
            this.loadDesignItem(StateChange.idDesignItem);
        }

        if (this.props.location.state && this.props.location.state.fallbackpath){
            StateChange.fallbackpath = this.props.location.state.fallbackpath;
        }
        else{
            if (StateChange.mode == "new"){
                if (StateChange.idDesign){
                    StateChange.fallbackpath = `/design/${StateChange.idDesign}`;
                }        
            }
        }

        if (StateChange.mode == null){
            StateChange.mode = 'view';
        }

        this.setState(StateChange);
        
    }

    handleChange(event) {

        const FormFieldName = event.target.name;
        let FormFieldValue = event.target.value;

        if (event.target.type == "checkbox"){
            FormFieldValue = event.target.checked;
        }

        let FormData = this.state.FormData;
        FormData[FormFieldName] = FormFieldValue;        
        this.setState({"FormData": FormData});

        return;
    };
    
    handleSubmit(event) {

        const onError = function(e){
            let StateChange = {};
            StateChange.renderState = "error";

            StateChange.errorMessage = e.message;

            if (e.response){
                if (e.response.data){
                    if (e.response.data.message){
                        StateChange.errorMessage = e.response.data.message;
                    }
                    if (e.response.data.fields){
                        for (const field in e.response.data.fields){
                            StateChange.invalidFields = e.response.data.fields
                        }
    
                    }
                }
            }
    
            this.setState(StateChange);
            return;
        }.bind(this);

        window.scrollTo(0, 0);

        switch (event.target.name){
            
            case 'btnCancel':

                this.setState({                    
                    renderState: "cancelled"
                })

                switch (this.state.mode){
                    case "edit":
                        this.props.navigation(`/designitem/${this.state.idDesignItem}`);
                        break;
                    case "new":
                        if (this.state.fallbackpath){
                            this.props.navigation(`${this.state.fallbackpath}`);
                        }
                        break;
                }

                break;
            case 'btnSave':
            default:

                this.setState({
                    isUpdated: false,
                    isFailed: false,
                    renderState: "updating"
                })
        
                switch (this.state.mode){
                    case 'new':
                        const onAdd = function(idDesignItem){
                            this.props.navigation(`/designitem/${idDesignItem}`);
                            return;
                        }.bind(this);

                        addDesignItemToDesign(this.dsd, this.state.idDesign, this.state.FormData, onAdd, onError);
                        break;
                    case 'edit':
                        const onUpdate = function(){
                            this.props.navigation(`/designitem/${this.state.idDesignItem}`);
                            return;
                        }.bind(this);

                        editDesignItem(this.dsd, this.state.idDesignItem, this.state.FormData, onUpdate, onError);
                        break;
                    default:
                        break; 
                };
    
        };

        event.preventDefault();
    }

    handleMode(event) {
        this.setState({mode: event.target.value});
        event.preventDefault();
    }

    handleButton(event) {

        let StateChange = {};

        switch (event.target.name){
        }

        this.setState(StateChange);

        event.preventDefault();
    };

    get Breadcrumb(){
        let crumbs = [
            {path: "/designs", label: "Designs"}
        ];

        if (this.state.Design){
            crumbs.push({
                path: `/design/${this.state.Design._id}`,
                label: this.state.Design.name
            });
        }

        if (this.state.DesignItem){
            crumbs.push({
                path: `/designitem/${this.state.idDesignItem}`,
                label: this.state.DesignItem.name
            });
        }

        return crumbs;
    }

    render() {

        switch (this.state.renderState){
            case "invalid":
            case "failed":
            case "denied":
                let Message = "An error has occured";
                if (this.state.errorMessage){
                    Message = this.state.errorMessage;
                }
                return <PD.ErrorBox>{Message}</PD.ErrorBox>
                break;
            case "loading":
                return <Buffering/>
                break;
            case "cancelled":
                return <p>Cancelled</p>
                break;
        }

        switch (this.state.mode){
            case 'new':
            case 'edit':

                switch (this.state.renderState){
                    case "loaded":
                    case "updating":
                    case "error":
                        return (
                            <div>

                                <PD.Heading>{this.state.mode} Design Item</PD.Heading>

                                {this.state.renderState == "error" &&
                                    <PD.ErrorBox>ERROR - Failed to Update</PD.ErrorBox>
                                }

                                <form> 
                                    <PD.Input label="Name" width="60" name="name" value={this.state.FormData.name} onChange={this.handleChange}/>
                                    <PD.Input label="Reference" width="60" name="reference" value={this.state.FormData.reference} onChange={this.handleChange}/>

                                    <PD.Editor label='Definition' name="definition" value={this.state.FormData.definition} onChange={this.handleChange}/>
                                    <PD.Editor label='Sources' name="sources" value={this.state.FormData.sources} onChange={this.handleChange}/>
                                    <PD.Editor label='Rules' name="rules" value={this.state.FormData.rules} onChange={this.handleChange}/>
                                    <PD.Editor label='Resources' name="resources" value={this.state.FormData.resources} onChange={this.handleChange}/>
                                    <PD.Editor label='Alternatives' name="alternatives" value={this.state.FormData.alternatives} onChange={this.handleChange}/>
                                    <PD.Editor label='Stakeholders' name="stakeholders" value={this.state.FormData.stakeholders} onChange={this.handleChange}/>
                                    <PD.Editor label='Law' name="law" value={this.state.FormData.law} onChange={this.handleChange}/>
                                    <PD.Editor label='Standards' name="standards" value={this.state.FormData.standards} onChange={this.handleChange}/>

                                    <PD.Select label="Status" name='status'  onChange={this.handleChange} value={this.state.FormData.status}>
                                        {
                                            this.dsd.config.ComponentStatuses.map(
                                                (status, posStatus) => 
                                                    {
                                                        return(
                                                            <option key={posStatus} value={status}>{status}</option>
                                                        )
                                                    }
                                            )
                                        }
                                    </PD.Select>
                                    
                                    {(() => {
                                        switch (this.state.renderState) {
                                            case "updating":
                                                return (
                                                    <div>
                                                        <PD.Button disabled={true} type="submit" name="btnSave">
                                                            <Buffering/>
                                                        </PD.Button>
                                                    </div>
                                                )
                                            default:
                                                return (
                                                    <div>
                                                        <PD.Button type="submit" onClick={this.handleSubmit} name="btnSave" value="Save" />    
                                                        <PD.Button type="warning" onClick={this.handleSubmit} name="btnCancel" value="Cancel" /> 
                                                    </div>
                                                )
                                        }
                                    })()}

                                </form>

                            </div>    
                        );
                }
                break;
            case 'remove':
                return (
                    <div>
                        <PD.Heading>{this.state.mode} Design Item</PD.Heading>

                        {this.state.isFailed &&
                            <PD.ErrorBox>ERROR - Failed to Update</PD.ErrorBox>
                        }

                        <PD.Button onClick={this.handleSubmit} type="warning" value="confirm remove?" />
                        <ViewDesignItem DesignItem={this.state.DesignItem}/>
                    </div>
                )
            case 'view':
            default:
                
                switch (this.state.renderState){
                    case "loaded":

                        return (
                            <div>
                                <div>
                                    <PD.Breadcrumb crumbs={this.Breadcrumb}/>
                                    <PD.Heading>Design Item:{this.state.DesignItem.name}</PD.Heading>
                                </div>

                                {this.state.OfferEdit &&
                                    <span style={{paddingRight:10}}>
                                            <PD.Button onClick={this.handleMode} type="submit" value="edit" />                        
                                    </span>
                                }

                                <ViewDesignItem DesignItem={this.state.DesignItem}/>

                                <br/>

                                <PD.Tabs>

                                    <div label='Design'>
                                        <ViewDesign Design={this.state.Design} />
                                    </div>

                                    <div label='Metadata'>
                                        <ViewMetadata Data={this.state.DesignItem} />
                                    </div>

                                    <div label='Developer'>
                                        <table>
                                            <tbody>
                                                {this.state.DesignItem &&
                                                    <tr>
                                                        <th style={{verticalAlign:"top"}}>DSD</th>
                                                        <td><pre>
                                                            {JSON.stringify(this.state.DesignItem,null,4)}{"\n\n"}
                                                        </pre></td>
                                                    </tr>
                                                }
                                            </tbody>
                                        </table>
                                    </div>

                                </PD.Tabs>

                            </div>
                        )
                }
        };

        return <div />;
    };
}

// Wrap and export
export default function DesignItem_wrapper(props) {
    
    const navigation = useNavigate();
    const location = useLocation();
    const params = useParams();

    return <DesignItem {...props} navigation={navigation} location={location} params={params} />;
}
